import React, { useEffect } from 'react';
import { Link } from "gatsby"
import $ from "jquery"

import Layout from "../components/layout"
import Image from "../components/image"
import SEO from "../components/seo"
import Staff from "../components/staff"
import File from "../components/file"

import Dm01 from "../images/DM01.jpg"
import Dm02 from "../images/DM02.jpg"
import Dm03 from "../images/DM03.jpg"




const About = () => {
  return (
    <Layout>
      <SEO title="Sweep - Space - Surface について"></SEO>
      <div className={"contents about"}>
        <div className={'door'}>
          <Image src={'ssslogo-line-black.svg'} className={'door_logo'} />
        </div>
        <div className={'content'}>
          <p className={'overview'}>
            2020年度卒業制作展「Sweep - Space - Surface」は本図録に収録された作家の中の有志者により企画された企画展です。
            作品の展示のみならず、それに関連したトークや公開講評や音声配信コンテンツが企画されました。
          </p>
          <div className={'exhibit hasc1'}>
            <h2>Exhibit</h2>
            <div className={'detail c1'}>
              <h3>開催概要</h3>
              <p className={""}>多摩美術大学 美術学部 情報デザイン学科 メディア芸術コース 2020年度卒業制作展<br />Sweep - Space - Surface</p>
              <p>主催 / 企画 : 多摩美術大学美術学部情報デザイン学科メディア芸術コース 2020年度卒業制作展「Sweep - Space - Surface」実行委員会</p>
              <p>会期 : 2021年3月24日(水)〜28(日)　- 11:00 ~ 19:00</p>
              <p>
                会場 : <a href="http://www.bankart1929.com/bank2020/space/kaiko/index.html" target="_blank" rel="noopener noreferrer">BankART KAIKO</a> / <a href="http://www.bankart1929.com/bank2020/space/station/index.html" target="_blank" rel="noopener noreferrer">BankART Station</a>
              </p>
              <p>
                〔webサイト〕<br />
                <a href="http://www.idd.tamabi.ac.jp/art/exhibit/gw20/" target="_blank" rel="noopener noreferrer">http://www.idd.tamabi.ac.jp/art/exhibit/gw20/</a>
              </p>
              <p>
                〔Twitter〕<br /><a href="https://twitter.com/iddart_2020" target="_blank" rel="noopener noreferrer">https://twitter.com/iddart_2020</a>
              </p>
              <p>
                〔Email〕<br /><a href="mailto:iddart.graduation.2020@gmail.com">iddart.graduation.2020@gmail.com</a>
              </p>
            </div>
            <div className={'detail c1'}>
              <h3>会場のようす</h3>
              <Image src={'exh_KAIKO01.jpg'} className={''} />
              <Image src={'exh_KAIKO02.jpg'} className={''} />
              <Image src={'exh_KAIKO03.jpg'} className={''} />
              <Image src={'exh_KAIKO04.jpg'} className={''} />
              <Image src={'exh_KAIKO05.jpg'} className={''} />
              <Image src={'exh_KAIKO06.jpg'} className={''} />
              <Image src={'exh_Station01.jpg'} className={''} />
              <Image src={'exh_Station02.jpg'} className={''} />
              <Image src={'exh_Station03.jpg'} className={''} />
              <Image src={'exh_Station04.jpg'} className={''} />
              <Image src={'exh_KAIKO07.jpg'} className={''} />
            </div>
          </div>
          <div className={'events hasc1'}>
            <h2>Events</h2>
            <p>本展の開催にあたり、さまざまなイベントを企画しました。</p>
            <div className={'talk c1'}>
              <h3>S-S-S Talk</h3>
              <p>
                会期中毎日 16:00 〜、BankART Station にて、多岐にわたるゲストをお招きし、昨今の美術の潮流やその構造など、様々な視点から話し合いました。
              </p>
              <ul>
                <li>
                  <h4><a href={'https://www.youtube.com/watch?v=6rS0TxtmPYY'}>3/24 (水) SIDE CORE × 伊藤亜紗　浮かび上がる身体 / 都市 / 記憶 / ストリートカルチャー / 認識</a></h4>
                </li>
                <li>
                  <h4><a href={'https://www.youtube.com/watch?v=jE6dwEij3Wk'}>3/25 (木) 佐々木敦 × 津田道子　語り / 演劇 / 主体 / 眼差し / 時空間</a></h4>
                </li>
                <li>
                  <h4><a href={'https://www.youtube.com/watch?v=utrLP7NoDWM'}>3/26 (金) 教授陣 × 学生対談 司会 小田原のどか　メディア芸術 / 美術教育 / 大学制度 / ジェンダー</a></h4>
                </li>
                <li>
                  <h4><a href={'https://www.youtube.com/watch?v=LlzoWHn7JmQ'}>3/27 (土) 迎英里子 × 小林エリカ　公共的なものにおける個人性 / 行為 / システム / 追体験</a></h4>
                </li>
                <li>
                  <h4><a href={'https://www.youtube.com/watch?v=xPsNOVL3wVI'}>3/28 (日) 谷口暁彦 × 遠藤麻衣　遊びと態度 / ゲーム / 脱臼 / 遊び場 / ソフト・プレイ</a></h4>
                </li>
              </ul>
            </div>
            <div className={'newsletter c1'}>
              <h3>S-S-S Letter</h3>
              <p>
                会期までの7日間、毎日1通のニュースレター ( Podcast ) を配信する企画です。ゲストに芸術人類学者 / 造形作家の中島智さんをお迎えし、展示に関わる様々なテーマについて、展示作家と1対1で話し合いました。
              </p>
              <ul>
                <li>
                  <h4>
                    <span><a className={'anchor'} href="https://anchor.fm/sweep---space---surface/episodes/Sweep---Space---Surface-Newsletter-vol-1-espul7/a-a4v8tec" rel="noopener noreferrer">vol.1 「 キャラクター 」</a></span><Link to={'/artists/zone2/Sawa'}>沙羽</Link> / <Link to={'/artists/zone3/ushioK'}>うしお鶏</Link>
                  </h4>
                </li>
                <li>
                  <h4>
                    <span><a className={'anchor'} href="https://anchor.fm/sweep---space---surface/episodes/Sweep---Space---Surface-Newsletter-vol-2-essvvl/a-a4vko96" rel="noopener noreferrer">vol.2 「 図像が成立する瞬間 」</a></span><Link to={'/artists/zone3/Mashimi'}>ましみ</Link>
                  </h4>
                </li>
                <li>
                  <h4>
                    <span><a className={'anchor'} href="https://anchor.fm/sweep---space---surface/episodes/Sweep---Space---Surface-Newsletter-vol-1-espul7/a-a4v8tec" rel="noopener noreferrer">vol.3 「 女性性の表象と月経 」</a></span><Link to={'/artists/zone1/Endo_Sana'}>遠藤 サナ</Link>
                  </h4>
                </li>
                <li>
                  <h4>
                    <span><a className={'anchor'} href="https://anchor.fm/sweep---space---surface/episodes/Sweep---Space---Surface-Newsletter-vol-4-et2iuk/a-a50b46r" rel="noopener noreferrer">vol.4 「 ゲーム内世界における心霊写真と人類学的手法 」</a></span><Link to={'/artists/zone3/Takahashi_Ryohei'}>高橋 遼平</Link>
                  </h4>
                </li>
                <li>
                  <h4>
                    <span><a className={'anchor'} href="https://anchor.fm/sweep---space---surface/episodes/Sweep---Space---Surface-Newsletter-vol-5-et4fm6/a-a50hb5a" rel="noopener noreferrer">vol.5 「 木について 」</a></span><Link to={'/artists/zone2/lowpolydog'}>lowpolydog</Link>
                  </h4>
                </li>
                <li>
                  <h4>
                    <span><a className={'anchor'} href="https://anchor.fm/sweep---space---surface/episodes/Sweep---Space---Surface-Newsletter-vol-6----et7cm0/a-a50to5k" rel="noopener noreferrer">vol.6 「 生き生きとした表象 - 生き生きとは何か 」</a></span><Link to={'/artists/zone3/Yonezawa_Shu'}>米澤 柊</Link>
                  </h4>
                </li>
                <li>
                  <h4>
                    <span><a className={'anchor'} href="https://anchor.fm/sweep---space---surface/episodes/Sweep---Space---Surface-Newsletter-vol-7-et7g40/a-a50tumn" rel="noopener noreferrer">vol.7 「 記憶について 」</a></span><Link to={'/artists/zone2/WANG_Jieyu'}>王婕妤 WANG Jieyu</Link>
                  </h4>
                </li>
              </ul>
            </div>
          </div>
          <div className={'artdirection'}>
            <h2>Items</h2>
            <div className={'mainviduals'}>
              <div className={'text'}>
                <h3>本展示メインヴィジュアル制作について</h3>
                <p>
                  このオブジェクトたちの大元は「Sweep - Space - Surface」、略してS - S - Sの文字の連なりを表したドローイングである。この形を元手にやわらかな膜を持った自由に形を変えるオブジェクトたちを、全体にコラージュして表現している。<br />
                「Sweep - Space - Surface」は個人とその周りの関係を表した展示タイトルで、このメインビジュアルもそのような考え方で作られた。<br />
                言わずもがな、人は常に心や思考を持っており、私たちはそれをじっと見つめ、解体して再構成し、制作し続けている。<br />
                人のそれは常に変化し続け、あらゆる事象と境界面で触れ合いまた変化を起こす。その変化は触れたものをさらにまた変化させるかもしれない、まるで流動体のように。
                </p>
                <p>
                  今年瞬く間に広まった、例外が原則に、原則が例外になるほどの生活の変化は私たちの心や思考の変化を、大きくまた急速に変えていくものだった。気候が暖かくなっても部屋にこもることはまるで、外で降り続ける大雪から逃れるように布団にくるまって家で過ごす感覚で、彩度の高い緑色の眩しい陽気の届く窓際にいても今年の冬は続いているようだった。<br />
                未だ根本的な解決法は決して見つかっているわけではない。しかし、難しいゲームの新しいステージを失敗するたびにちょっとずつ攻略のコツを掴んでいくように、私たちはこの生活の変化を攻略している。それは流動体だから、それを取り込むような形になって、新しい形の流動体で復旧していく。そうしていくことで新しい春の兆しを見つけることができる。見つけている。<br />
                </p>
                <p>
                  私たちはこの展示でより新しい私たちの持つ心や思考を解体して再構成した表現を展開する。<br />
                </p>
                <p>
                  そのような考えのもとこのメインビジュアルを展開した。<br />
                </p>
              </div>
              <div className={'image'}>
                <Image src={'main-vidual_vartical.png'} />
                <p>▲ メインビジュアル</p>
                <Image src={'main-vidual_holizontal.png'} />
                <p>▲ メインビジュアル（ 横 ）</p>
                <div className={'logos'}>
                  <Image src={'sweep-space-surface_holizontal_black.svg'} />
                  <div>
                    <Image src={'ssslogo-line-black.png'} />
                    <Image src={'ssslogo-fill-black.png'} />
                  </div>
                  <p>▲ ロゴタイプ / ロゴマーク</p>
                </div>
              </div>
            </div>
            <div className={'dms c1'}>
              <h3>ダイレクトメール</h3>
              <Image src={"DM02.jpg"} className={''} />
              <Image src={"DM03.jpg"} className={''} />
              <p>
                photo : 竹久直樹
              </p>
            </div>
            <div className={'teaser c1'}>
              <h3>ティザー映像</h3>
              <div className={'iframeWrap'}>
                <iframe src={"https://www.youtube.com/embed/0r9_BlpJhho"} frameBorder="0" allow="accelerometer; autoplay; clipboard - write; encrypted - media; gyroscope; picture -in -picture" allowFullScreen></iframe>
              </div>
              <p><a href="https://www.youtube.com/watch?v=0r9_BlpJhho" target="_blank" rel="noopener onreferrer">メディア芸術コース 2020年度 卒業制作展「Sweep-Space-Surface」ティザー</a></p>
            </div>
            <div className={'handout c1'}>
              <h3>ハンドアウト</h3>
              <Image src={"handout01.jpg"} className={''} />
              <Image src={"handout02.jpg"} className={''} />
            </div>
            <div className={'book_catalog c1'}>
              <h3>図録</h3>
              <Image src={"catalogbook01.jpg"} className={''} />
              <Image src={"catalogbook02.jpg"} className={''} />
            </div>
            <div className={'poster c1'}>
              <h3>ポスター</h3>
              <Image src={"poster01.jpg"} className={''} />
              <Image src={"poster02.jpg"} className={''} />
              <Image src={"poster03.jpg"} className={''} />
            </div>
            <div className={'staff_batch c1'}>
              <h3>スタッフバッチ</h3>
              <Image src={"staff_batch.jpg"} className={''} />
            </div>
            <div className={'staff_batch c1'}>
              <h3>サイン</h3>
              <Image src={"sign01.jpg"} className={''} />
              <Image src={"sign02.jpg"} className={''} />
            </div>
          </div>
          <div className={'staffs hasc1'}>
            <h2>スタッフ</h2>
            <Staff />
          </div>
          <div className={'staffs about hasc1'}>
            <h2>この図録について</h2>
            <table>
              <tbody>
                <tr className={'head'}>
                </tr>
                <tr>
                  <td>
                    <p>公開日</p>
                  </td>
                  <td>
                    <p>2021年3月24日</p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p>発行</p>
                  </td>
                  <td>
                    <p>多摩美術大学美術学部情報デザイン学科メディア芸術コース 2020年度卒業制作展「Sweep - Space - Surface」実行委員会</p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p>編集</p>
                  </td>
                  <td>
                    <p>米澤 柊　坂田 晶 lowpolydog 荒井 流衣　河野 真歩　鈴木さゆり　maya masuda　堀井野の花　瀬尾 美月</p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p>撮影</p>
                  </td>
                  <td>
                    <p>竹久直樹（ https://takehisanaoki.com/ ）</p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p>撮影補助</p>
                  </td>
                  <td>
                    <p>ならぶき りく（ 本コース3年 ）</p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p>撮影協力</p>
                  </td>
                  <td>
                    <p>高橋 遼平　鈴木 しおり　堀井 野の花　瀬尾 美月　柴田 将希　遠藤 サナ</p>
                  </td>
                </tr>
              </tbody>
            </table>
            <p>
              本書掲載の内容の無断転載・使用・借用・複写などを禁止します。<br />
            ©︎ 多摩美術大学 美術学部 情報デザイン学科 メディア芸術コース 2020年度卒業制作展 実行委員会
            </p>
          </div>
        </div>

      </div>
    </Layout >
  )
}

export default About